module.exports = __webpack_public_path__ + "static/media/border-leatherworking-tool.7c24f1de.webp";